import { NgModule } from '@angular/core';
import { OptionModuleInReply } from '../../../../reply';
import { OptionTextComponent } from './option-text.component';
import { AutosizeModule } from 'ngx-autosize';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [OptionModuleInReply, 
    AutosizeModule, 
    FormsModule,
  ],
  declarations: [OptionTextComponent],
  exports: [OptionTextComponent]
})
export class OptionTextModule {}
